module.exports = __webpack_public_path__ + "static/media/coffee.b7a59313.svg";